document.addEventListener('DOMContentLoaded', e => {

	document.getElementById('flyout-toggle').addEventListener('click', (e) => {
		/*
		const scrollY = window.scrollY;
		document.body.style.position = 'fixed';
		document.body.style.top = -1 * scrollY + 'px';
		*/
		document.body.classList.toggle('--flyout-open');

		tl.reversed() ? tl.play() : tl.reverse();

	});

	document.querySelectorAll('.has-sub-menu').forEach( (item) => {
		item.addEventListener('click', (e) => {
			e.target.closest('li').classList.toggle('--submenu-open');

		});
	});

	const upper = document.getElementsByClassName('upper');
	const middle = document.getElementsByClassName('middle');
	const lower = document.getElementsByClassName('lower');
	let tl = gsap.timeline({ paused: true, reversed: true });

	tl
	.to(upper, { y: 10.5, duration: 0.2, ease: "power2.inOut", transformOrigin: "13 0" }, 'init')
	.to(lower, { y: -10.5, duration: 0.2, ease: "power2.inOut", transformOrigin: "13 0" }, 'init')
	.to(upper, { rotation: 40, duration: 0.2, ease: "power2.inOut" }, 'start')
	.to(middle, { autoAlpha: 0, duration: 0.2 }, 'init')
	.to(lower, { rotation: -40, duration: 0.2, ease: "power2.inOut" }, 'start');

});
